import Vue from "vue";
import Router from "vue-router";
import { RouterTabRoutes } from "vue-router-tab";
Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      redirect: "/dashboard",
      component: () => import("@/view/layout/Layout"),
      children: [
        ...RouterTabRoutes,
        {
          path: "/dashboard",
          name: "dashboard",

          component: () => import("@/view/pages/Dashboard.vue"),
          meta: {
            title: "صفحه نخست",
          },
        },
        {
          path: "/acl/users",
          name: "aclusers",
          component: () => import("@/view/pages/acl/users.vue"),
          meta: {
            title: "کاربران",
          },
        },
        {
          path: "/acl/role/add",
          name: "roleadd",
          component: () => import("@/view/pages/acl/addrole.vue"),
          meta: {
            title: "افزودن نقش",
          },
        },
        {
          path: "/acl/permsstion/add",
          name: "permsstionadd",
          component: () => import("@/view/pages/acl/addpermsstion.vue"),
          meta: {
            title: "افزودن دسترسی",
          },
        },
        {
          path: "/lang",
          name: "lang",
          component: () => import("@/view/pages/lang/lang.vue"),
          meta: {
            title: "مدیریت زبان ها",
          },
        },

        {
          path: "/article/create",
          name: "articlecreate",
          component: () => import("@/view/pages/article/create.vue"),
          meta: {
            title: "ایجاد مطلب",
          },
        },

        {
          path: "/article/mng",
          name: "articlemng",
          component: () => import("@/view/pages/article/mng.vue"),
          meta: {
            title: "مدیریت مطالب",
          },
        },

        {
          path: "/article/edit/:id",
          name: "articleedit",
          component: () => import("@/view/pages/article/edit.vue"),
          meta: {
            title: "ویرایش مطلب",
            key: "path",
          },
        },

        {
          path: "/article/comments",
          name: "articlecomments",
          component: () => import("@/view/pages/article/comments.vue"),
          meta: {
            title: "مدیریت دیدگاه",
          },
        },

        {
          path: "/article/taxnomy",
          name: "articletaxnomy",
          component: () => import("@/view/pages/article/taxnomy.vue"),
          meta: {
            title: "مدیریت موضوعات",
          },
        },
        {
          path: "/video/create",
          name: "video-create",
          component: () => import("@/view/pages/video/create.vue"),
          meta: {
            title: "ایجاد ویدئو",
          },
        },
        {
          path: "/video/manager",
          name: "video-manager",
          component: () => import("@/view/pages/video/manager.vue"),
          meta: {
            title: "مدیریت ویدئوها",
          },
        },
        {
          path: "/video/edit/:id",
          name: "video-edit",
          component: () => import("@/view/pages/video/edit.vue"),
          meta: {
            title: "ویرایش ویدئو",
            key: "path",
          },
        },
        {
          path: "/layout/index",
          name: "layout-edit",
          component: () => import("@/view/pages/layout/edit.vue"),
          meta: {
            title: "ویرایش صفحه نخست",
            key: "path",
          },
        },
      ],
    },

    {
      path: "/",
      component: () => import("@/view/pages/auth/login_pages/Login-1"),
      children: [
        {
          name: "login",
          path: "/login",
          component: () => import("@/view/pages/auth/login_pages/Login-1"),
        },
      ],
    },
    {
      path: "*",
      redirect: "/404",
    },
    {
      // the 404 route, when none of the above matches
      path: "/404",
      name: "404",
      component: () => import("@/view/pages/auth/login_pages/Login-1"),
    },
  ],
});
